import { render, staticRenderFns } from "./ServicesToOfferSection.vue?vue&type=template&id=242e0891&scoped=true"
import script from "./ServicesToOfferSection.vue?vue&type=script&lang=js"
export * from "./ServicesToOfferSection.vue?vue&type=script&lang=js"
import style0 from "./ServicesToOfferSection.vue?vue&type=style&index=0&id=242e0891&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e0891",
  null
  
)

export default component.exports